export default {
    // to standardize all display dates
    methods: {
        dateFormat(date) {
            return moment(date).format('DD/MM/YYYY hh:mm:ss A');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/date-format.js